// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.myStyle[data-v-54ce3f88] {\n  min-height: calc(100vh - 55px - 55px - 20px - 20px - 55px);\n}\n", ""]);
// Exports
module.exports = exports;
